module.exports = __webpack_public_path__ + "static/media/maloos-logo.064aa3a7.png";